import React, { Component } from 'react'
import '../css/general-style.css'

/**
 * LoadingWindow — modern full-screen loading overlay.
 *
 * Same API as before: use a ref and call showState(true/false).
 *
 *   this.ModalLoading = React.createRef();
 *   <LoadingWindow ref={this.ModalLoading} />
 *   this.ModalLoading.current.showState(true);   // show, default "Loading..." label
 *   this.ModalLoading.current.showState(false);  // hide
 *
 * Optional second argument overrides the label — used by the server
 * connectivity check (see functions/serverConnectionCheck.js) to show
 * progress text like "Checking the server connection. Please wait".
 *
 *   this.ModalLoading.current.showState(true, 'Checking the server connection. Please wait');
 */
export default class LoadingWindow extends Component {

    state = {
        active: false,
        label: 'Loading'
    }

    showState(status, label) {
        this.setState({ active: status, label: label || 'Loading' });
    }

    render() {
        if (!this.state.active) return null;

        return (
            <div className="loading-overlay">
                <div className="loading-card">

                    {/* Dual-ring CSS spinner */}
                    <div className="loading-spinner" />

                    {/* Label with animated dots */}
                    <div className="loading-label">
                        {this.state.label}
                        <span className="loading-dot">.</span>
                        <span className="loading-dot">.</span>
                        <span className="loading-dot">.</span>
                    </div>

                    {/* Cancel */}
                    <button
                        className="loading-cancel"
                        onClick={() => this.showState(false)}
                    >
                        Cancel
                    </button>

                </div>
            </div>
        );
    }
}
